module.exports = __webpack_public_path__ + "img/reach-icon.12ef3140.svg";